module.exports = __webpack_public_path__ + "img/中国搜索.0e26089.0e260892.png";